import isEqual from 'react-fast-compare';

import { omit } from 'Lib/utils/lodashUtils';

import shallowEqual from './shallowEqual';

/**
 * Function to compare nested object
 * @param  {Object} a          object
 * @param  {Object} b          compare object
 * @param  {Array} nestedKeys  nested key
 * @param  {Boolean} compareNested should deep compare nestedKey
 * @return {Boolean}           is equal
 */
export default function shallowEqualNested(
  a: any,
  b: any,
  nestedKeys: string[],
  compareNested: boolean | undefined = true
) {
  const rootCompare = shallowEqual(omit(a, nestedKeys), omit(b, nestedKeys));
  const nestedCompare = !compareNested ? true : !nestedKeys.some((key) => !isEqual(a[key], b[key]));
  return rootCompare && nestedCompare;
}
